import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME} from './constants';

class SestavyApi extends BaseApi {
	async GetAppointmentListReport(workShopIds:Number[], appointmentDateFrom:string, appointmentDateTo:string, columnSequence:any){
		return this.downloadXlsxReport(`/${DMS_MODULE}/AppointmentList/GetAppointmentListReport?workshopIds=${workShopIds}&appointmentDateFrom=${appointmentDateFrom}&appointmentDateTo=${appointmentDateTo}&ColumnSequence=${columnSequence}`,'AppointmentListReport.xlsx');
	}

	constructor() {
		super(DMS_MODULE, API_NAME);
	}	
}

export const apiProvider = new SestavyApi();
